import { parse as parseQueryString } from 'querystring';

import { searchQueryTextKey } from '@ms/yammer-web-support/dist/urls';
import { useLocation } from 'react-router-dom';

type UseLocationSearchText = () => string | undefined;

export const useLocationSearchText: UseLocationSearchText = () => {
  const { search: queryString } = useLocation();
  const { [searchQueryTextKey]: searchText } = parseQueryString(queryString.slice(1));

  if (searchText == null || typeof searchText !== 'string') {
    return undefined;
  }

  return searchText;
};
